import { withCorrelationHeader } from "./requestCorrelation";

export const appendNoStoreCacheBuster = (
  url,
  {
    origin =
      typeof window !== "undefined" && window.location
        ? window.location.origin
        : "http://localhost",
    param = "_",
    value = Date.now(),
  } = {}
) => {
  const nextUrl = new URL(url, origin);
  nextUrl.searchParams.set(param, String(value));
  return nextUrl.toString();
};

const buildNoStoreHeaders = (headers) => {
  const next = new Headers(headers || undefined);
  next.delete("Expires");
  if (!next.has("Cache-Control")) next.set("Cache-Control", "no-cache");
  if (!next.has("Pragma")) next.set("Pragma", "no-cache");
  return next;
};

// Request & Correlation Foundation: callers running one logical operation may
// pass `correlationId`; it is attached as the X-Cphere-Correlation-Id header
// (validated — an invalid id attaches nothing). It is a transport option,
// never forwarded to fetch, and there is deliberately no global default:
// unrelated requests never share one permanent correlation id.
export const buildNoStoreRequestOptions = ({ correlationId, ...options } = {}) => ({
  ...options,
  cache: "no-store",
  headers: withCorrelationHeader(buildNoStoreHeaders(options.headers), correlationId),
});

export const noStoreFetch = (url, options = {}) =>
  fetch(appendNoStoreCacheBuster(url), buildNoStoreRequestOptions(options));
